import EventEmitter from 'methods/eventEmitter';

/**
 * Инициализация модалки чекбоксов
 * @param {Object} container - html контейнер. Пример: $('#hotel_calendar')
 * @param {Object} dataContainer - Контейнер где лежат данные. Пример: $('.js-hotelData')
 * @param {Object} alias - alias для input. Пример: $('.js-hotelData')
 */
function KurortCheckboxSearch(args) {
    // входные данные
    const obj = this;
    const $container = args.container;
    const isMobile = args.isMobile || false;
    const $renderContainer = args.container.querySelector('.js-renderContainer');
    const onChangeCallback = args.onChangeCallback || false;
    const canBeEmpty = args.canBeEmpty || false;
    const checkboxType = args.checkboxType || 'checkbox';
    const prefixTitle = args.prefixTitle || '';
    const fieldName = $container.getAttribute('data-field-name');
    let currentType = 'default';
    this.diff_days = 0;
    this.beforeData = {};
    const values = args.values || [];

    // наследуемся
    EventEmitter.call(obj, {});

    const initPositions = {};
    const initDataJson  = $container.getAttribute('data-json');

    this.setChecked = function (value, state, event = true) {
        const $input = $container.querySelector(`input[type="checkbox"][name="${fieldName}[${value}]"]`);

        if (!$input) {
            throw new Error('Input not found');
        }

        const $checkboxItemContainer = $input.closest('.js-checkboxItemContainer');
        const $checkboxItem = $checkboxItemContainer.querySelector('.js-checkboxItem');
        const $checkboxField = $checkboxItemContainer.querySelector('.js-checkboxField');

        $checkboxItem.classList.toggle('is-active', state);
        $checkboxField.checked = state;

        if (state) {
            $checkboxField.setAttribute('checked', 'checked');
        } else {
            $checkboxField.removeAttribute('checked');
        }

        obj.emit('select', {
            name: $checkboxField.name,
            state,
        });

        $container.querySelectorAll('.js-checkboxItemContainer').forEach($element => {
            $element.dispatchEvent(new Event('change', { bubbles: true, cancelable: true, }));
        });

        if (typeof onChangeCallback === 'function') {
            onChangeCallback();
        }
    }

    this.check = function (value) {
        this.setChecked(value, true);
    }

    this.uncheck = function (value) {
        this.setChecked(value, false);
    }

    this.toggle = function (value) {
        this.setChecked(value, !this.checked(value));
    }

    this.checked = function (value) {
        return $container.querySelector(`input[type="checkbox"][name="${fieldName}[${value}]"]`).checked;
    }

    /**
     * Инициализация
     */
    this.init = function() {
        values.forEach(value => this.check(value));

        // если есть чекнутые элементы - раскрываем блок
        const $checked = $renderContainer.querySelectorAll('.js-checkboxField:checked');

        if ($checked.length) {
            let $showMore = $container.querySelector('.js-showMore');

            $renderContainer.classList.add('is-open');
            
            if ($showMore) {
                $showMore.classList.add('is-open');
                $showMore.querySelector('span').textContent = 'Скрыть';
            }
        }

        this.initEventHandlers();
    }

    this.initEventHandlers = function() {
        $container.addEventListener('click', (e) => {
            /**
             * Клик по радио кнопке
             */
            if (e.target.closest && e.target.closest('.js-radioItemContainer')) {
                e.preventDefault();
                e.stopPropagation();
    
                const $radioItemContainer = e.target.closest('.js-radioItemContainer');
                const $radioItem = $radioItemContainer.querySelector('.js-radioItem');
    
                // повторный клик
                if ($radioItem.classList.contains('is-active')) {
                    return false;
                }
    
                // снимаем со всех
                $container.querySelectorAll('.js-radioItem').forEach($button => {
                    $button.classList.remove('is-active');
                });
    
                // ставим на выбранный
                $radioItem.classList.add('is-active');
    
                // сохр значение в input
                $container.querySelector('.js-radioField').value = $radioItemContainer.getAttribute('data-value');
    
                $container.querySelectorAll('.js-radioItemContainer').forEach($element => {
                    $element.dispatchEvent(new Event('change', { bubbles: true, cancelable: true, }));
                });
    
                if (typeof onChangeCallback === 'function') {
                    onChangeCallback();
                }
            }

            /**
             * Клик по чекбоксу
             */
            if (e.target.closest && e.target.closest('.js-checkboxItemContainer')) {
                e.preventDefault();
                e.stopPropagation();

                const $checkboxItemContainer = e.target.closest('.js-checkboxItemContainer');
                const $input = $checkboxItemContainer.querySelector('input[type="checkbox"]');
                const match = $input.name.match(/^(\w+)\[(\d+)\]/);
                const [key, value] = [match[1], match[2]];

                this.toggle(value);
            }

            /**
             * Клик по показать/скрыть
             */
            if (e.target.closest && e.target.closest('.js-showMore')) {
                const $more = e.target.closest('.js-showMore');
                
                $more.classList.toggle('is-open');

                $renderContainer.classList.toggle('is-open');
                const isOpen = $renderContainer.classList.contains('is-open');
                const $span  = $more.querySelector('span');
    
                $span.textContent = isOpen ? 'Скрыть' : 'Показать всё';
            }
        });
    }

    this.reset = function() {
        if (checkboxType === 'radio') {
            $container.querySelectorAll('.js-radioItem').forEach($item => {
                $item.classList.remove('is-active');
            });

            $container.querySelectorAll('.js-radioField').forEach($item => {
                $item.value = 0;
            });
        }

        if (checkboxType === 'checkbox') {
            $container.querySelectorAll('.js-checkboxItem').forEach($item => {
                $item.classList.remove('is-active');
            });

            $container.querySelectorAll('.js-checkboxField').forEach($item => {
                $item.checked = false;
            });
        }
    }

    /**
     * Пересчет доступных чекбоксов
     */
    this.recalc = function(list = false, type = 'default', diff_days = 0) {
        // во избежание мутации
        list = JSON.parse(JSON.stringify(list));
        list = list || [];

        this.diff_days = diff_days;

        if (Array.isArray(list)) {
            $container.classList.toggle('is-hidden', !list.length);
        } else {
            if (canBeEmpty) {
                $container.classList.add('is-hidden');
                return;
            }
        }

        // если турист выбраз стоимость за день, то запоминаем это и не переключаем на периоды, при выборе дат например!
        currentType = type === 'default' ? currentType : type;
        type        = currentType;

        let render = '';
        if (checkboxType === 'radio') {
            render += `<input name="${fieldName}" type="hidden" class="Kurort-sidebar__radio js-radioField" value="${$renderContainer.querySelector('.js-radioField').value}">`;
        }

        list.forEach(item => {
            // то, что тут дублируется item.checked в условие не опечатка!
            const active = !!item.checked;
            const checked = active;
            const disabled = !item.count;

            let title = item.title;

            if (type === 'day' && item.day_title.length > 0) {
                title = item.day_title;
            }

            if (type === 'period' && item.period_title.length > 0) {
                title = item.period_title;
            }

            this.beforeData[item.id] = item;

            // радиокнопки
            if (checkboxType === 'radio') {
                if (isMobile) {
                    render += `<div class="Kurort-filters__check${disabled ? ' disabled' : ''}">\
                                    <div class='Kurort-filters__check-inner js-radioItemContainer' data-value="${item.id}" data-title="${title}">\
                                        <div class="Kurort-filters__custom-radio js-radioItem${active ? ' is-active' : ''}"></div>\
                                        <span class="js-title">${title}</span>\
                                    </div>\
                                    <span class="Kurort-filters__num">${item.count}</span>\
                                </div>`
                } else {
                    render += `<div class="Kurort-sidebar__check${disabled ? ' disabled' : ''}">\
                                    <div class="Kurort-sidebar__check-inner js-radioItemContainer" data-value="${item.id}" data-title="${title}">\
                                        <div class="Kurort-sidebar__custom-radio js-radioItem${active ? ' is-active' : ''}"></div>\
                                        <span class="js-title">${title}</span>\
                                    </div>\
                                    <span class="Kurort-sidebar__num">${item.count}</span>\
                                </div>`;
                }
            }

            // чекбоксы - по умолчанию
            if (checkboxType === 'checkbox') {
                if (isMobile) {
                    render += `<div class="Kurort-filters__check${disabled ? ' disabled' : ''}">\
                                    <div class='Kurort-filters__check-inner js-checkboxItemContainer'>\
                                        <div class="Kurort-filters__custom-checkbox js-checkboxItem${active ? ' is-active' : ''}"></div>\
                                        <input name="${fieldName}[${item.id}]" type="checkbox" class="Kurort-filters__checkbox js-checkboxField"\
                                            data-type="${fieldName}" data-id="${item.id}"${checked ? ' checked' : ''} value="${title}" aria-label="${title}">\
                                        <span class="js-title">${title}</span>\
                                    </div>\
                                    <span class="Kurort-filters__num">${item.count}</span>\
                                </div>`
                } else {
                    render += `<div class="Kurort-sidebar__check${disabled ? ' disabled' : ''}">\
                                    <div class="Kurort-sidebar__check-inner js-checkboxItemContainer">\
                                        <div class="Kurort-sidebar__custom-checkbox js-checkboxItem${active ? ' is-active' : ''}"><span class="js-title">${title}</span></div>\
                                        <input name="${fieldName}[${item.id}]" type="checkbox" class="Kurort-sidebar__checkbox js-checkboxField"${checked ? ' checked' : ''} data-type="${fieldName}" data-id="${item.id}" value="${title}" aria-label="${title}">\
                                    </div>\
                                    <span class="Kurort-sidebar__num">${item.count}</span>\
                                </div>`;
                }
            }
        });

        if ($container.querySelector('.js-showMore')) {
            $container.querySelector('.js-showMore').remove();
        }

        const isOpen = $renderContainer.classList.contains('is-open');

        $container.insertAdjacentHTML('beforeend',
            `<button type="button" class="Kurort-sidebar__showAll js-showMore${isOpen ? ' is-open' : ''}">
                <span>${isOpen ? 'Скрыть' : 'Показать всё'}</span>
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.48719 0.769271L4.93848 4.27834L1.38977 0.769271C1.17268 0.554612 0.818374 0.554612 0.60129 0.769271C0.384205 0.98393 0.384205 1.33428 0.60129 1.54894L4.5448 5.44728C4.76188 5.66194 5.11619 5.66194 5.33328 5.44728L9.27566 1.54894C9.49275 1.33428 9.49275 0.98393 9.27566 0.769271C9.05858 0.554612 8.70427 0.554612 8.48719 0.769271Z" fill="#0089FD"/>
                </svg>
            </button>`
        );

        if (list.length <= 6) {
            $container.querySelector('.js-showMore').classList.add('is-hidden');
        } else {
            $container.querySelector('.js-showMore').classList.remove('is-hidden');
        }

        $renderContainer.innerHTML = render;
    }

    /**
     * Че-то выбрано
     */
    this.isInit = function() {
        if (checkboxType === 'radio') {
            return [...$renderContainer.querySelectorAll('.js-radioField')].some($radio => {
                return +$radio.value !== 0;
            });
        }

        if (checkboxType === 'checkbox') {
            return $renderContainer.querySelectorAll('.js-checkboxField:checked').length !== 0;
        }
    }

    /**
     * Возвращает че-то
     */
    this.getCheckedOptions = function() {
        const list = [];

        if (checkboxType === 'checkbox') {
            const $list = $renderContainer.querySelectorAll('.js-checkboxField:checked');

            $list.forEach($item => {
                list.push({
                    id: $item.dataset.id,
                    type: fieldName,
                    title: $item.value,
                });
            });
        }

        if (checkboxType === 'radio' && obj.isInit()) {
            let title = prefixTitle ? prefixTitle + ' ' : '';
                title = title + $renderContainer.querySelector('.js-radioItem.is-active').parentElement.getAttribute('data-title');

            list.push({
                id: $renderContainer.querySelector('.js-radioField').value,
                type: fieldName,
                title: title,
            });
        }

        return list;
    }

    this.recalcByType = function(type) {
        if (this.diff_days == 0) {
            return;
        }

        $container.querySelectorAll('.js-checkboxItemContainer').forEach($item => {
            let $input = $item.querySelector('input[data-id]');
            let $title = $item.querySelector('.js-title');
            if (!$title || !$input) {
                return;
            }

            let data = this.beforeData[$input.dataset.id];
            $title.textContent = this.modifyTitle({
                type,
                data,
            });
        });
    }

    this.modifyTitle = function(args = {}) {
        let {
            type,
            data,
        } = args;

        if (type === 'day') {
            return data.day_title;
        }

        if (type === 'period') {
            return data.period_title;
        }
    }

    this.getCurrentType = function() {
        return currentType;
    }
}

// цепочка прототипов
KurortCheckboxSearch.prototype = Object.create(EventEmitter.prototype, {
    constructor: {
        value: KurortCheckboxSearch,
        enumerable: false,
        writable: true,
    }
});

export default KurortCheckboxSearch;
